import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openModal, closeModal } from '../../redux/app';
import Trades from '../../components/instrument/trades/Trades';
import withTableSubscription from '../../hoc/withTableSubscription';
import { requestTradeData, tradeDataReceived } from '../../actions/trades';
import normalizeSymbol from '../../service/normalizesymbol';
import { getTradesSourceForSymbol } from '../../selectors';

function mapStateToProps({ app, trades }, { symbol }) {
    const nSymbol = normalizeSymbol(symbol);
    const instrument = trades[nSymbol] || {};
    const sources = getTradesSourceForSymbol(nSymbol);
    const { columns, limit } = trades;
    const start = new Date().setHours(0, 0, 0, 0).toString();

    // Filter ITEM_SECTOR uses the regular symbol,
    // thus we can't use the normalized one.
    const filter = `ITEM_SECTOR==s${symbol}`;

    return {
        columns,
        filter,
        limit,
        sources,
        start,
        isLoading: instrument.isLoading || false,
        modalOpen: app.modalOpen === 'trades',
        symbol,
        trades: instrument.trades || [],
    };
}

function mapDispatchToProps(dispatch, { symbol }) {
    const nSymbol = normalizeSymbol(symbol);
    const dispatchers = bindActionCreators({
        requestTradeData,
        openModal,
        closeModal,
    }, dispatch);

    const create = (data) => dispatch(
        tradeDataReceived(nSymbol, data)
    );

    const update = (key, values) => dispatch(
        tradeDataReceived(nSymbol, [{ key, values }])
    );

    return { ...dispatchers, create, update };
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withTableSubscription(Trades)
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/instrument/Trades.js
 **/